export default __webpack_public_path__ + "static/leon-fe76ff3521894c429c9ec1487e5586ac.png";